import type { MemberAccessRule } from './types.js';

export const GO_MEMBER_ACCESS_RULES: MemberAccessRule[] = [
  { parentType: 'selector_expression', objectField: 'operand', propertyField: 'field', tagKind: 'member' },
];
